import types from '../../types/types';

const initialState = {
    charging: false
};

const authReducer = ( state = initialState, action: any ) => {

    switch ( action.type ) {
        
        case types.authLogin:
            return {
                ...state,
                ...action.payload
            }

        case types.authCheckingFinish:
            return {
                ...state,
                charging: true
            }

        case types.authLogout:
            return {
                charging: true
            }


        default:
            return state;
    }

}

export default authReducer;

